// Lib
import * as _ from 'lodash';
import { put, call, takeLatest } from "redux-saga/effects";

// Constants
import * as ACTIONS from "./actionTypes";

// Types
import { ActionGetOfferInsightsAPI, GetOfferInsightsAPISuccess, GetOfferInsightsAPIError, ActionGetOfferInsightStatsAPI, GetOfferInsightStatsAPISuccess, GetUsesrSettingsAPISuccess, GetUsesrSettingsAPIError } from './actions';
import { ActionGetProfilePerformanceInsightStatsAPI, GetProfilePerformanceInsightStatsAPISuccess, GetProfilePerformanceInsightStatsAPIError,ActionGetUserSettingsAPI, SetRangeDates, ActionUserSettingsInfoAPI } from './actions';
import { Specials, Stats, UserSetting } from './types';
import { ProfilePerformanceStats } from './types';

import { createAPINetworkInstance } from '../../../../common/api';
import { } from './utils';

function* getOfferInsights(action: ActionGetOfferInsightsAPI) {
    try {        
        const dateRange = (action.dateRange) ? `&startDate=${action.dateRange.startDate.format("MM-DD-YYYY hh:mm:ss").toString()}&endDate=${action.dateRange.endDate.format("MM-DD-YYYY hh:mm:ss").toString()}` : ``;
        const { iddealer, search, orderby, filters, offset, limit } = action
        const { data } = yield call(createAPINetworkInstance().get, `dealer/${iddealer}/offerInsights?search=${search}&orderby=${orderby}&filters=${filters}&offset=${offset}&limit=${limit}${dateRange}`);
        const resultSearch: Specials = data;
        yield put(GetOfferInsightsAPISuccess(resultSearch, offset));
    } catch (err) {
        yield put(GetOfferInsightsAPIError(err));
    }
}


function* getOfferInsightsStats(action: ActionGetOfferInsightStatsAPI) {
    try {        
        const { iddealer } = action
        const dateRange = (action.dateRange) ? `?startDate=${action.dateRange.startDate.format("MM-DD-YYYY hh:mm:ss").toString()}&endDate=${action.dateRange.endDate.format("MM-DD-YYYY hh:mm:ss").toString()}` : ``;
        const { data } = yield call(createAPINetworkInstance().get, `dealer/${iddealer}/offerInsightStats${dateRange}`);
        const result: Stats = data;
        yield put(GetOfferInsightStatsAPISuccess(result));
    } catch (err) {
        yield put(GetOfferInsightsAPIError(err));
    }
}

function* getProfilePerformanceStats(action: ActionGetProfilePerformanceInsightStatsAPI) {
    try {                
        const { iddealer } = action
        const dateRange = (action.dateRange) ? `?startDate=${action.dateRange.startDate.format("MM-DD-YYYY hh:mm:ss").toString()}&endDate=${action.dateRange.endDate.format("MM-DD-YYYY hh:mm:ss").toString()}` : ``;        
        const { data } = yield call(createAPINetworkInstance().get, `engine/GMB/dealer/${iddealer}/performanceInsightStats${dateRange}`);
        const result: ProfilePerformanceStats = data;
        
        yield put(GetProfilePerformanceInsightStatsAPISuccess(result));
    } catch (err) {
        yield put(GetProfilePerformanceInsightStatsAPIError(err));
    }
}

function* getUsersSettings(action: ActionGetUserSettingsAPI) {
    try {        
        const query = (action.filter) ? `?filter=${action.filter}&orderby=${action.orderby}` : ``;
        const { data } = yield call(createAPINetworkInstance().get, `userssettings${query}`);
        const result: UserSetting[] = data;
        yield put(GetUsesrSettingsAPISuccess(result[0]));
    } catch (err) {
        yield put(GetUsesrSettingsAPIError(err));
    }
}

function* saveUserSettings(action: ActionUserSettingsInfoAPI) {
    try {
        const { data } = yield call(createAPINetworkInstance().post, `userssettings`, action.userInfo);
        const result: UserSetting[] = data;
        yield put(GetUsesrSettingsAPISuccess(action.userInfo));
    } catch (err) {
        yield put(GetUsesrSettingsAPIError(err));
    }
}

function* updateUserSettings(action: ActionUserSettingsInfoAPI) {
    try {
        const { data } = yield call(createAPINetworkInstance().put, `userssettings`, action.userInfo);
        const result: UserSetting[] = data;
        yield put(GetUsesrSettingsAPISuccess(action.userInfo));
    } catch (err) {
        yield put(GetUsesrSettingsAPIError(err));
    }
}

export default function* offerInsightsSagas() {
    yield takeLatest(ACTIONS.GET_OFFER_INSIGHTSTATS_API_REQUEST, getOfferInsightsStats);
    yield takeLatest(ACTIONS.GET_PROFILE_PERFORMANCE_INSIGHTS_API_REQUEST, getProfilePerformanceStats);
    yield takeLatest(ACTIONS.GET_OFFER_INSIGHTS_API_REQUEST, getOfferInsights);
    yield takeLatest(ACTIONS.GET_USER_SETTING_API_REQUEST, getUsersSettings);
    yield takeLatest(ACTIONS.SAVE_USER_SETTING_API_REQUEST, saveUserSettings);
    yield takeLatest(ACTIONS.UPDATE_USER_SETTING_API_REQUEST, updateUserSettings);
}
